export default __webpack_public_path__ + "falken.47d55c.svg";